import {
  defaultColumnDefinition,
  defaultColumnDefinitionWithFilter,
} from '../../shared/columnDefinitions';
import { dateCellFormatter } from '../../shared/formatters/index';
import { EditableCheckboxCellRenderer } from '../../shared/columnDefinitions/cellRenderers';

const getColumnDefinitions = () => {
  const columnDefinitions = [
    {
      ...defaultColumnDefinitionWithFilter,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      headerName: 'Job ID',
      field: 'jobId',
      width: 160,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Status',
      field: 'status',
      width: 160,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Job Type',
      field: 'jobType',
      width: 160,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Submit Date',
      field: 'submitTime',
      width: 100,
      valueFormatter: dateCellFormatter,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Mail Subject',
      field: 'mailSubject',
      width: 280,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Note',
      field: 'note',
      width: 590,
    },
  ];
  return columnDefinitions;
};
export default getColumnDefinitions;
